let ccwLanguageButton = document.getElementById("ccw-language-button");
let ccwLanguageDropdown = document.getElementById("ccw-language-dropdown");

ccwLanguageButton.addEventListener("click", function () {
  // Check button current state.
  this.classList.toggle("language-selector--open");
  this.setAttribute(
    "aria-expanded",
    `${!(this.getAttribute("aria-expanded") === "true")}`
  );
  ccwLanguageDropdown.classList.toggle("language-dropdown--open");
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeLanguageDropdown();
  }
});

document.addEventListener("click", function (e) {
  if (
    (e.target.getAttribute("class") !== null &&
      !e.target
        .getAttribute("class")
        .split(/[ __]+/)
        .includes("language-selector")) ||
    e.target.parentElement
      .getAttribute("class")
      .includes("language-dropdown__btn")
  ) {
    closeLanguageDropdown();
  }
});

function closeLanguageDropdown() {
  ccwLanguageButton.setAttribute("aria-expanded", "false");
  ccwLanguageButton.classList.remove("language-selector--open");
  ccwLanguageDropdown.classList.remove("language-dropdown--open");
}

/*
 *  Function for CCW word not to translate, wherever exists in the site, by wrapping into a span with attribute data-recite-trasnlate-skip.
 *  Only affects text content and not e.g. img alt texts.
 *  Case sensitive using regex patern to keep CCW word not translated.
 */

export function wrapCcwForNoTranslate(node) {
  const walker = document.createTreeWalker(
    node,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  const regex = /\bccw\b/gi;
  const nodesToProcess = [];

  let currentNode;
  while ((currentNode = walker.nextNode())) {
    if (regex.test(currentNode.nodeValue)) {
      nodesToProcess.push(currentNode);
    }
  }

  nodesToProcess.forEach((textNode) => {
    const parts = textNode.nodeValue.split(regex);
    if (parts.length <= 1) return;

    const fragment = document.createDocumentFragment();
    const matches = textNode.nodeValue.match(regex);

    for (let i = 0; i < parts.length; i++) {
      fragment.appendChild(document.createTextNode(parts[i]));

      if (i < parts.length - 1) {
        const span = document.createElement("span");
        span.setAttribute("data-recite-translate-skip", "true");
        span.textContent = matches[i];
        fragment.appendChild(span);
      }
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  wrapCcwForNoTranslate(document.body);
});
